'use strict';
const calculateFishboneLeftToRightLayout = require('./calculate-fishbone-left-to-right-layout');
module.exports  = function calculateFishboneRightToLeftLayout(idea, dimensionProvider, margin, layout) {
	const nodes = calculateFishboneLeftToRightLayout(idea, dimensionProvider, margin, layout);
	Object.values(nodes).forEach(n => {
		n.x = -1 * n.x - n.width;
	});
	return nodes;
};

